import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Box,
  Button,
  Flex,
  HStack,
  Link,
  Spinner,
  Text,
  VStack
} from '@chakra-ui/react';
import {
  clearOrderDetails,
  getOrderByIdWithResource
} from '@store/actions/ordersActions';
import { Link as ReactLink } from 'react-router-dom';
import { BsArrowRight } from 'react-icons/bs';
import { FaArrowLeft } from 'react-icons/fa';
import DynamicDataViewer from '@components/DynamicDataViewer';

const OrderDetailsCard = ({
  orderId,
  userId,
  orderResource,
  isSidebar = false,
  showNavLink = false,
  showGoBackBtn = true,
  onGoBackClick,
}) => {
  const dispatch = useDispatch();

  const { data: orderDetails, isLoading } = useSelector(
    (state) => state.orders.orderDetails
  );

  useEffect(() => {
    dispatch(getOrderByIdWithResource({ orderId, orderResource }));
  }, [orderId, orderResource, dispatch]);

  useEffect(() => {
    return () => dispatch(clearOrderDetails());
  }, [dispatch]);

  if (isLoading) {
    return (
      <Flex m={'1rem'} justifyContent={'center'} alignItems={'center'}>
        <Spinner color="brand.600" />
      </Flex>
    );
  }

  return (
    <Box position={'relative'}>
      <Box
        maxH={isSidebar ? '85vh' : 'none'}
        className="scroll-sm"
        overflow={isSidebar ? 'auto' : 'inherit'}
      >
        <VStack alignItems={'stretch'}>
          {showNavLink && userId && (
            <HStack
              px={4}
              spacing={2}
              justifyContent={showGoBackBtn ? 'space-between' : 'flex-end'}
              alignItems={'center'}
              w={'full'}
            >
              {showGoBackBtn && (
                <Button
                  colorScheme={'ghost'}
                  size="sm"
                  bg="backGround"
                  border="2px solid"
                  borderColor="whiteAlpha.500"
                  borderRadius="xl"
                  p={2}
                  leftIcon={<FaArrowLeft color="white" />}
                  onClick={onGoBackClick}
                  fontSize="xs"
                >
                  Go Back
                </Button>
              )}
              <Link
                as={ReactLink}
                to={`/user/${userId}?orderId=${orderId}&orderResource=${orderResource}`}
                target="_blank"
              >
                <Button
                  colorScheme={'brand'}
                  size="sm"
                  bg="backGround"
                  border="2px solid"
                  borderColor="whiteAlpha.500"
                  borderRadius="xl"
                  p={2}
                  rightIcon={<BsArrowRight />}
                >
                  <Text fontSize={'xs'}>Navigate to User Detail</Text>
                </Button>
              </Link>
            </HStack>
          )}
          <DynamicDataViewer
            data={orderDetails}
            maxH={isSidebar ? '85vh' : 'none'}
            className="scroll-sm"
            overflow={isSidebar ? 'auto' : 'inherit'}
            defaultDispatchOnSuccess={() =>
              dispatch(
                getOrderByIdWithResource({
                  orderId,
                  orderResource
                })
              )
            }
          />
        </VStack>
      </Box>
    </Box>
  );
};

export default OrderDetailsCard;
